import { useRouter } from "vue-router"

export function useCrudNavigation(resource) {
    const router = useRouter()

    async function navigateToMainPage() {
        await router.push({ name: `manager.${resource}` })
    }

    async function navigateToViewPage(id) {
        await router.push({ name: `manager.${resource}.view`, params: { id } })
    }

    async function navigateToEditPage(id) {
        await router.push({ name: `manager.${resource}.edit`, params: { id } })
    }

    async function navigateToCreatePage() {
        await router.push({ name: `manager.${resource}.create` })
    }

    return {
        navigateToMainPage,
        navigateToViewPage,
        navigateToEditPage,
        navigateToCreatePage,
    }
}
